import React, { useEffect } from 'react';
import Close from '../../../../static/close.svg';
import RedArrowBack from '../../../../static/redArrowBack.svg';
import * as styles from './modal.module.scss';
import { ListingOtQuery } from '../../../../graphql-types';
import { usePageContext } from '../../../hooks/contexts/usePageContext';
import { DeviceEnum } from '../../../utils/getDevice';
import { useWindowSize } from '../../../hooks/useWindowSize';

interface IModalProps {
  children: React.ReactNode;
  open: boolean;
  setOpenModal: (open: boolean) => void;
  translations?: ListingOtQuery['sanityTranslations'];
  fullScreenMobile: boolean;
}

export const Modal = ({
  children,
  open,
  setOpenModal,
  translations,
  fullScreenMobile,
}: IModalProps) => {
  const { device } = useWindowSize();
  const { lang } = usePageContext();

  useEffect(() => {
    if (device === DeviceEnum.mobile || device === DeviceEnum.tablet)
      document.body.style.overflow = open ? 'hidden' : 'auto';
  }, [open]);

  if (!open) return null;
  return (
    <div className={`${open ? styles.wrapper : ''}`}>
      <div
        // open={open}
        className={`${
          fullScreenMobile && device === DeviceEnum.mobile ? styles.fullScreenModal : styles.modal
        } ${open ? styles.open : ''}`}
      >
        {children}
        <Close
          onClick={() => setOpenModal(false)}
          className={`${
            fullScreenMobile && device === DeviceEnum.mobile ? styles.close : styles.closeNotFull
          }`}
        />
        {fullScreenMobile && (
          <div onClick={() => setOpenModal(false)} className={styles.back}>
            <div className={styles.icon}>
              <RedArrowBack />
            </div>
            <div className={styles.backReturn}>{translations?._rawModalFilterReturn?.[lang]}</div>
          </div>
        )}
      </div>
    </div>
  );
};
